import { LanguageDto } from "./languagedto";
import { PaginationFeaturesDto } from "./paginationfeaturesdto";


export class LanguageRequest {

    languageDto: LanguageDto = new LanguageDto();
    
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});

}
